@if (selectedGridFilterTags.length) {
<div class="grid-filters-tags-container">
    <span hSrOnlyNoSnippet [attr.role]="'heading'" aria-level="3">
        <ng-container i18n="@@hermes.accessibility.selected_filters">Selected filters</ng-container>
    </span>
    <ul class="ul-grid-filters-tags">
        @for (tag of selectedGridFilterTags; track tag.id) {
        <li>
            <h-grid-filter-tag
                class="grid-filters-tag"
                [gridFilterTag]="tag"
                (remove)="removeFilter(tag)"></h-grid-filter-tag>
        </li>
        }
        <li>
            <h-grid-filter-clear></h-grid-filter-clear>
        </li>
    </ul>
</div>
}
